import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Checkbox } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { materialTableTheme } from '../../../shared/utils/smartutils';
import PendencyTag from './PendencyTag';

const PendingRecordItem = ({
  pendingItem,
  t,
  onSelectHandler,
  itemIndex,
  title,
  tagValue,
  date,
  hourDate,
  tagColor,
}) => {
  return (
    <div className="pendency-item-card">
      <div className="check">
        <ThemeProvider theme={materialTableTheme}>
          <Checkbox
            checked={!!pendingItem.selected}
            onChange={(event) => onSelectHandler(event, itemIndex, pendingItem)}
          />
        </ThemeProvider>
      </div>
      <div className="pendency-item-info">
        <p className="pendency-title tooltip-test text-ellipsis">{title}</p>
        <div className="pendency-item-detail">
          <PendencyTag value={tagValue} color={tagColor} />
          <div className="pendency-hour">{`${date} ${t(
            'general.at'
          )} ${hourDate}`}</div>
        </div>
      </div>
    </div>
  );
};

PendingRecordItem.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  tagValue: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  hourDate: PropTypes.string.isRequired,
  pendingItem: PropTypes.shape({
    id: PropTypes.number,
    studentName: PropTypes.string,
    levelOne: PropTypes.string,
    dateNote: PropTypes.string,
    hourNote: PropTypes.string,
    selected: PropTypes.bool,
  }),
  onSelectHandler: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  tagColor: PropTypes.string.isRequired,
};

PendingRecordItem.defaultProps = {
  pendingItem: {},
};

export default withTranslation('common')(memo(PendingRecordItem));
